import { useState, useRef } from "react";
import { api, imgUrl, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ImageUpload = ({ value, onChange, label = "Image" }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-2">
      <Label className="label-eyebrow text-[#5E5A54]">{label}</Label>
      <div className="flex gap-3 items-start">
        {value ? (
          <img src={imgUrl(value)} alt="preview" className="w-20 h-20 object-cover border border-[#ECEAE4]" />
        ) : (
          <div className="w-20 h-20 bg-[#F6F5F2] border border-dashed border-[#C9C2B6] flex items-center justify-center text-[#9E8773]">
            <Upload size={18} />
          </div>
        )}
        <div className="flex-1 space-y-2">
          <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="Paste an image URL or upload" className="rounded-none bg-white border-[#ECEAE4]" data-testid="image-url-input" />
          <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid="image-file-input" />
          <Button type="button" variant="outline" size="sm" disabled={uploading} onClick={() => inputRef.current?.click()} className="rounded-none border-[#ECEAE4] label-eyebrow text-[10px]" data-testid="image-upload-button">
            {uploading ? <Loader2 size={14} className="animate-spin mr-1" /> : <Upload size={14} className="mr-1" />}
            {uploading ? "Uploading…" : "Upload file"}
          </Button>
        </div>
      </div>
    </div>
  );
};
